<template>
  <div>
    <!-- 头部start -->
    <crumbs :activeIndex="5"></crumbs>
    <!-- 头部 end-->
    <!-- 广告start -->
    <div class="y-advertisement">
      <img src="../../static/img/tourist.png" alt />
    </div>
    <!-- 广告end -->
    <!-- 导航start -->
    <div class="y-navigation">
      <div class="min y-navigation-box">
        <div class="router-active">
          <img src="../../static/img/icon.png" alt />
          <router-link to="/">首页 ></router-link>游客服务>
          <span style="color:#0078ff">{{scale}}</span>
        </div>
      </div>
    </div>
    <!-- 导航end -->

    <div class="services-content min">
      <div
        class="services-item"
        v-for="(service,index) in serviceList"
        :key="service.id"
        :class="{active:index==activeIndexs}"
        @click="select(service,index)"
      >
        <div  v-if="index==activeIndexs" >
          <div   v-for="(ser,index) in serviceLists" :key="index" >
          <img :src="ser.img" v-if="index==activeIndexs" alt />
          </div>
        </div>
        <div v-else>
          <img :src="baseURL+service.Pic" alt />
        </div>

        <p>{{service.Title}}</p>
      </div>
    </div>

    <div class="service-gray-content min">
      <h4>{{revel.Title||Title}}</h4>
     <!--  <div class="service-gray-reason">{{revel.Intr||Intrs}}</div> -->
      <div class="service-gray-reason" v-html="revel.Description">{{ revel.Description }}</div>
    </div>

    <!-- 友情链接start -->
    <tab></tab>

    <!-- 友情链接end -->
    <Footer></Footer>
  </div>
</template>
<script>
import tab from "@/components/tab.vue";
export default {
  components: {
    tab
  },
  data() {
    return {
      activeIndexs: "",
      serviceList: [],
      serviceLists: [
        {img:"../../static/img/service1.png"},
        {img:"../../static/img/service2.png"},
        {img:"../../static/img/service3.png"},
        {img:"../../static/img/service4.png"}
      ],
      Intr: [],
      baseURL:window.SITE_CONFIG.baseUrl+'/yxht',
      revel: {},
      Intrs: "",
      scale: "服务中心",
      Title:""
    };
  },
  created() {
    this.service();
  },

  methods: {
    service() {
      this.$http
        .get("yxapi//api/News/GetNewsList", {
          CategoryId: "d42b92a3-5113-458a-a363-2a38cb6b08ae",
          page: 1,
          size: 4
        })
        .then(res => {
           let formList =  JSON.parse(res.data.Result).rows;
          this.service = JSON.parse(res.data.Result);
          this.serviceList = this.service.rows;
          this.Intr = this.service.rows.Intr;
          this.Intrs = this.service.rows[0].Intr;
          this.Title = this.service.rows[0].Title;
          let itemlist = formList[0]
          console.log('formList', formList);
           itemlist.Description = formList[0].Description.replace(
              /\<img src="/gi,
             '<img style="margin:0 auto" src="http://www.sxszstm.com'
            );
          this.revel = itemlist;
          console.log(this.Intrs);
        });
    },
    // services() {
    //   this.$http
    //     .get("yxapi//api/News/GetNewsList", {
    //       CategoryId: "ea351f7d-caba-4d27-b87e-6672aa240672",
    //       page: 1,
    //       size: 4
    //     })
    //     .then(res => {
    //       this.services = JSON.parse(res.data.Result);
    //       this.serviceLists = this.service.rows;
    //       console.log(this.serviceLists,9966)
    //       this.Intrs = this.service.rows.Intr;
    //       this.Intrss = this.service.rows[0].Intr;
    //       console.log(this.Intrs);
    //     });
    // },
    select(service, index) {
      console.log(999999, index);
      console.log("soul:", service.Description);
      let itemlist = service
      this.scale = service.Title;
      this.revel = service;
      this.revel.Description = itemlist.Description.replace(
              /\<img src="/gi,
             '<img style="margin:0 auto" src="http://www.sxszstm.com'
            );

      this.activeIndexs = index;
    }
  }
};
</script>
<style  scoped>
.service-gray-content {
  margin-bottom: 60px;
  height: auto;
}
.service-gray-reason{
  padding: 30px 0;

}
.router-active {
  display: flex;
  align-items: center;
  height: 60px;
}
.router-active img {
  width: 17px;
  height: 20px;
  margin-right: 6px;
}
.router-link-active {
  color: #000000;
}
.y-advertisement {
  width: 100%;
  height: 340px;
}
.y-advertisement img {
  width: 100%;
  height: 100%;
}
.active {
  width: 94px;
  height: 116px;
  transition: all 0.8s;
  vertical-align: middle;
  color: #0078ff;
  cursor: pointer;
}
.active:hover {
  transform: scale(1.2);
}
h4{
  text-align: center;
    padding-top: 60px;
    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #000000;
    line-height: 24px;
}
</style>



// WEBPACK FOOTER //
// src/view/services.vue